import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'
import { fetchStudentsMarks, getStudentMarks } from '../../redux/action/facultyAction'
import FacultyHomeHelper from '../../Components/FacultyHomeHelper'
import { useHistory, Link } from 'react-router-dom';



const FacultyUploadMarks = () => {
    const store = useSelector((store) => store)
    const history = useHistory()
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false);
    const [year, setYear] = useState("")
    const [semester, setSemester] = useState("")

    const [marks, setMarks] = useState([])
    const [section, setSection] = useState("")
    const [subjectCode, setSubjectCode] = useState("")
    const [exam, setExam] = useState("")
    const [error, setError] = useState({})
    const [errorHelper, setErrorHelper] = useState({})
    const [sortedResults, setSortedResults] = useState([]);
    const [pass, setPass] = useState(0);
    const [fail, setFail] = useState(0);
    const [absents, setAbsents] = useState(0);
    const [totalMarks, setTotalMarks] = useState(0);
    useEffect(() => {
        const { pass, fail, absents, totalMarks } = (store.faculty.studentMarkList.result || []).reduce(
            (accumulator, obj) => {
                const markIndex = (store.faculty.studentMarkList.result || []).findIndex(
                    (item) => item.registrationNumber === obj.registrationNumber
                );
                const mark = (store.faculty.studentMarkList.studentMark || [])[markIndex];
    
                if (mark >= 40) {
                    accumulator.pass++;
                } else if (mark < 40 && mark >= 1) {
                    accumulator.fail++;
                } else if (mark === 0) {
                    accumulator.absents++;
                }
    
                accumulator.totalMarks += mark;
    
                return accumulator;
            },
            { pass: 0, fail: 0, absents: 0, totalMarks: 0 }
        );
    
        setPass(pass);
        setFail(fail);
        setAbsents(absents);
        setTotalMarks(totalMarks);
    }, [store.faculty.studentMarkList.result, store.faculty.studentMarkList.studentMark]);
    

    const department = store.faculty.faculty.faculty.department;
    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])

    useEffect(() => {
        if (store.errorHelper) {
            setErrorHelper(store.errorHelper)
        }
    }, [store.errorHelper])

    const formHandler = (e) => {
        e.preventDefault()

        dispatch(fetchStudentsMarks(department, year, section, semester))

    }
    const secondFormHandler = (e) => {
        e.preventDefault()
        dispatch(getStudentMarks(subjectCode, exam, department, section, semester, year))
    }

    return (
        <div>
            {store.faculty.isAuthenticated ? <>
                <div className="container-fluid p-0">
                    <div className="d-flex">
                        <div className="print-helper">
                            <FacultyHomeHelper />
                        </div>
                        <div className="mx-1 w-100 ">
                            <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="/logo192.png" width={'50px'} alt="" />Student Marks</h3>
                                <button onClick={() => window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <div className="col d-md-flex align-items-center justify-content-between ">
                                <form
                                    className="d-md-flex align-items-center justify-content-start"
                                    noValidate
                                    onSubmit={formHandler}
                                >
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="yearId">Year</label>
                                        <select
                                            onChange={(e) => setYear(e.target.value)}
                                            className={classnames('form-control', {
                                                'is-invalid': error.year
                                            })}
                                            id="yearId"
                                        >
                                            <option>Select</option>
                                            <option value="I">1</option>
                                            <option value="II">2</option>
                                            <option value="III">3</option>
                                            <option value="IV">4</option>
                                        </select>
                                        {error.year && (
                                            <div className="invalid-feedback">{error.year}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="sectionId">Section</label>
                                        <select
                                            onChange={(e) => {
                                                setSection(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section
                                            })}
                                            id="sectionId"
                                        >
                                            <option>Select</option>
                                            <option value="A">A</option>
                                            <option value="B">B</option>
                                            <option value="C">C</option>
                                            <option value="D">D</option>
                                        </select>
                                        {error.section && (
                                            <div className="invalid-feedback">{error.section}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2 print-helper">
                                        <label htmlFor="semesterId">Semester</label>
                                        <select
                                            onChange={(e) => {
                                                setSemester(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section
                                            })}
                                            id="semesterId"
                                        >
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                        </select>
                                        {error.semester && (
                                            <div className="invalid-feedback">{error.semester}</div>
                                        )}
                                    </div>
                                    <div className="mt-3">
                                        {!isLoading && (
                                            <button
                                                type="submit"
                                                className="btn btn-info btn-block print-helper "
                                            >
                                                <img
                                                    src="/image/search.svg"
                                                    className="mb-1"
                                                    alt=""
                                                />{' '}
                                                Search
                                            </button>
                                        )}
                                        {isLoading && (
                                            <div
                                                className="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        )}
                                    </div>
                                </form>
                                <button className='btn btn-success print-helper ' > <Link to="/FacultyUploadMark" className='text-light'> <img src="/image/add.svg" alt="" /> Upload Marks</Link></button>
                            </div>
                            <div className="row justify-content-center m-0">
                                <div className="col">
                                    <form className="d-md-flex align-items-center justify-content-start" onSubmit={secondFormHandler}>
                                        <div className="form-group mx-3">
                                            <label htmlFor="subjectId">Subject Name</label>
                                            <select
                                                onChange={(e) => setSubjectCode(e.target.value)}
                                                className={classnames("form-control", {
                                                    'is-invalid': errorHelper.subjectCode
                                                })}
                                                id="subjectId"
                                            >
                                                <option>Select</option>
                                                {store.faculty.allStudentMarkList.subjectCode?.map((subject, index) => (
                                                    <option key={subject} value={subject}>
                                                        {store.faculty.allStudentMarkList.subjectName?.[index]}
                                                    </option>
                                                ))}
                                            </select>
                                            {errorHelper.subjectCode && (<div classNameName="invalid-feedback">{errorHelper.subjectCode}</div>)}
                                        </div>
                                        <div className="form-group mx-3">
                                            <label htmlFor="examId">Exam</label>
                                            <select onChange={(e) => setExam(e.target.value)} value={exam} className={classnames("form-control",
                                                {
                                                    'is-invalid': errorHelper.exam

                                                })} id="examId">
                                                <option>Select</option>
                                                <option value="CycleTest1">Cycle Test 1</option>
                                                <option value="CycleTest2">Cylce Test 2</option>
                                                <option value="ModelExam">Model Exam</option>
                                            </select>
                                            {errorHelper.exam && (<div classNameName="invalid-feedback">{errorHelper.exam}</div>)}

                                        </div>
                                        <div className="mt-3">
                                            {!isLoading && (
                                                <button
                                                    type="submit"
                                                    className="btn btn-info btn-block print-helper "
                                                >
                                                    <img
                                                        src="/image/search.svg"
                                                        className="mb-1"
                                                        alt=""
                                                    />{' '}
                                                    Show Grid
                                                </button>
                                            )}
                                            {isLoading && (
                                                <div
                                                    className="spinner-border text-primary"
                                                    role="status"
                                                >
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                    <div>
                                    <table className="table table-bordered table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">Total Pass</th>
                                                    <th scope="col">Total Fail</th>
                                                    <th scope="col">Absents</th>
                                                    <th scope="col">Average</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{pass}</td>
                                                    <td>{fail}</td>
                                                    <td>{absents}</td>
                                                    <td>
                                                        {Array.isArray(store.faculty.studentMarkList.result) &&
                                                            store.faculty.studentMarkList.result.length > 0 &&
                                                            (totalMarks / store.faculty.studentMarkList.result.length).toFixed(2)}
                                                    </td>
                                                    {/* Add other table cells as needed */}
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table className="table table-bordered table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">S.NO</th>
                                                    <th scope="col">Registration Number</th>
                                                    <th scope="col">Student Name</th>
                                                    <th scope="col">Marks</th>
                                                    <th scope="col">Result</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(store.faculty.studentMarkList.result) &&
                                                    Array.isArray(store.faculty.studentMarkList.studentMark) &&
                                                    store.faculty.studentMarkList.result.map((obj, index) => {
                                                        const markIndex = store.faculty.studentMarkList.result.findIndex(
                                                            (item) => item.registrationNumber === obj.registrationNumber
                                                        );

                                                        const mark = store.faculty.studentMarkList.studentMark[markIndex];

                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{obj.registrationNumber}</td>
                                                                <td>{obj.name}</td>
                                                                <td>{mark}</td>
                                                                <td>
                                                                    {mark === 0 ? (
                                                                        <span className="badge badge-warning">Absent</span>
                                                                    ) : mark < 40 ? (
                                                                        <span className="badge badge-danger">Fail</span>
                                                                    ) : (
                                                                        <span className="badge badge-success">Pass</span>
                                                                    )}
                                                                </td>
                                                                {/* Add other table cells as needed */}
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </> : (history.push('/'))}

        </div>
    )
}

export default FacultyUploadMarks
